/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, getter-return */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import GradingMethod from '@linc-technologies/linced-common/enums/grading-method';

export default class AssessmentMultiGrader extends Component {
  @action
  setOnInput(value) {
    this.onInput = value;
  }

  // Services
  @service
  permissions;

  @service
  session;

  @service
  store;

  GradingMethod = GradingMethod;
  module = null;
  editGrade() {}
  onChange() {}
  @tracked onInput = null;

  get validationMessage() {
    if (!isEmpty(this.onInput)) {
      return this.onInput.target.validationMessage;
    }
  }

  @computed('mini', 'module.gradeSchedule.select.values.[]')
  get wrapIconSelect() {
    if (this.mini) {
      // In "mini" mode (i.e. group grading), only wrap if there are lots of
      // values; they wrap too aggressively in table cells.
      return this.get('module.gradeSchedule.select.values.length') > 6;
    }
    // Not "mini" - allow wrapping.
    return true;
  }

  @action
  setNumericGrade(option) {
    if (this.grade) {
      this.set('grade.grade', option);
    } else {
      let grade = {
        module: this.module,
        gradeType: GradingMethod.NUMERIC,
        grade: option,
      };
      this.editGrade(grade);
    }
  }

  @action
  setSelectGrade(option) {
    if (this.grade) {
      this.set('grade.grade', option.value);
    } else {
      let grade = {
        module: this.module,
        gradeType: GradingMethod.SELECT,
        grade: option.value,
      };
      this.editGrade(grade);
    }
  }

  @action
  setIconGrade(option) {
    if (this.grade) {
      this.set('grade.grade', option.value);
    } else {
      let grade = {
        module: this.module,
        gradeType: GradingMethod.ICON_SELECT,
        grade: option.value,
      };
      this.editGrade(grade);
    }
  }

  @action
  toggleMultiSelectGrade(option) {
    // Plain array, not A(): PaperChips's @content is read-only internally
    // (it delegates mutation to @addItem/@removeItem, both of which are
    // this same action) - and the this.set('grade.grade', ...) call below
    // is what actually triggers PaperChips to re-render (classic EmberObject
    // KVO on the `grade.grade` path), independent of the array's own type.
    const value = option.get('value');
    if (this.grade) {
      const options = this.get('grade.grade');
      let newOptions;
      if (options.includes(value)) {
        newOptions = options.filter((item) => item !== value);
      } else {
        newOptions = [...options, value];
      }
      this.set('grade.grade', newOptions);
    } else {
      let grade = {
        module: this.module,
        gradeType: GradingMethod.MULTIPLE_SELECT,
        grade: [value],
      };
      this.editGrade(grade);
    }
  }

  @action
  clear() {
    this.editGrade(this.grade, true);
  }

  getGrade(gradeType) {
    return gradeType;
  }
}
